import { useEffect, useMemo } from 'react';
import { useDashboardStore } from './dashboard';
import { parseState } from './parseState';
import { clearQueryQueue } from './queryManager';
import { useDispatch } from 'react-redux';
import { persistWidgets } from '@src/store/trends/base/actions';
import useFirstRender from '@src/hooks/utils/useFirstRender';

function useInitializeDashboard() {
  const dispatch = useDispatch();
  const first = useFirstRender();

  // cancel queued queries
  useEffect(() => {
    return () => {
      clearQueryQueue();
    };
  }, []);

  const state = useDashboardStore((state) => state);

  const { widgets, order } = state;
  // persistence
  useEffect(() => {
    // do not re-render based on `first`
    if (!first) {
      dispatch(persistWidgets());
    }
  }, [widgets, order]);

  // apply ordering
  const parsedState = useMemo(() => parseState(state), [state]);

  return parsedState;
}

export default useInitializeDashboard;
